import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useCurrentUser } from "hooks/useCurrentUser";

function CosmeticGuard({ children, ...rest }) {
  const { userDetails } = useCurrentUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        userDetails?.is_cosmetic_consultation_available ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/home",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default CosmeticGuard;
